module.exports = __webpack_public_path__ + "img/xiaoxie.e7cccd0b.jpeg";